import Vue from 'vue'
import VueRouter from 'vue-router'

//ADMINISTRACION
import Empresas from '../components/Administracion/Empresas'
import Usuarios from "../components/Administracion/Usuarios"
import Roles from "../components/Administracion/Roles"
import PermisosModulos from "../components/Administracion/PermisosModulos"

//CATALOGOS
import Clientes from "../components/Catalogos/Clientes"
import Sucursales from "../components/Catalogos/Sucursales"
import Configuracion from "../components/Catalogos/Configuracion"
import Servicios from "../components/Catalogos/Servicios"
import Vendedores from "../components/Catalogos/Vendedores"
import Productos from "../components/Catalogos/Productos"
import ConfiguracionSMTP from "../components/Catalogos/ConfiguracionSMTP"
import Proveedores from "../components/Catalogos/Proveedor"
import Consignatarios from "../components/Catalogos/Consignatarios.vue"
import PuntosVenta from "../components/Catalogos/PuntoVenta.vue"
import ConfiguracionCorte from "../components/Catalogos/ConfiguracionCorte.vue"
import BitacoraCorreoFe from "../components/Catalogos/BitacoraCorreosFe.vue"

//OTROS
import Bienvenido from "../components/Bienvenido"
import Login from "../components/Login"
import Paises from "../components/Pais"
import ReporteCliente from "../components/ReporteClientes"
import ReporteProveedor from "../components/ReporteProveedores"
import Pagos from "../components/Pagos"
import ResumenVentas from "../components/ResumenVentas"
import ExportacionFacturas from "../components/ExportacionFacturas.vue"

//import ExportarFacturaCSV from '@/components/ExportarFacturaCSV.vue'
//import ReporteVentaCompra from '@/components/ReporteVentaCompra.vue'

import indexFe from "../components/Facturacion/index.vue"
import index from '@/components/Compras/index.vue'
import indexIVA from '@/components/Libros/indexIVA.vue'
import indexReporte from '@/components/ReporteVC/indexReporte.vue'
import indexExportar from '@/components/ExportacionCSV/index.vue'
import index_expor_compras from '@/components/ExporComprasCSV/index.vue'
import indexAnexos from '@/components/AnexosIVA/index.vue'
import indexCxc from '@/components/ReporteriaG/index.vue'
//import LibrosIVA from '@/components/LibrosIVA.vue'

//CUENTAS POR COBRAR
import IngresosDiarios from "../components/CuentaPorCobrar/IngresosDiarios.vue"

//Permiso Botones
import PermisosBotones from "../components/Catalogos/ConfiguracionBotones.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'bienvenido',
    component: Bienvenido
  },
  {
    path: '/bitacora_correo_fe',
    name: 'Bitacora correo fe',
    component: BitacoraCorreoFe
  },
  {
    path: '/configuracion_corte',
    name: 'Configuracion corte',
    component: ConfiguracionCorte
  },
  {
    path: '/ingresos_diarios',
    name: 'Ingresos Diarios',
    component: IngresosDiarios
  },
  {
    path: '/puntos_venta',
    name: 'Puntos de venta',
    component: PuntosVenta
  },
  {
    path: '/consignatarios',
    name: 'Consignatarios',
    component: Consignatarios
  },
  {
    path: '/exportacion_facturas',
    name: 'Exportacion Facturas',
    component: ExportacionFacturas
  },
  {
    path: '/exportacion_fac_csv',
    name: 'Exportacion Facturas CSV',
    component: indexExportar
  },
  {
    path: '/expor_compras',
    name: 'Exportacion Compras',
    component: index_expor_compras
  },
  {
    path: '/resumen_ventas',
    name: 'ResumenVentas',
    component: ResumenVentas
  },
  {
    path: '/pagos',
    name: 'Pagos',
    component: Pagos
  },

  {
    path: '/reporte_clientes',
    name: 'Reporte clientes',
    component: ReporteCliente
  },
  {
    path: '/reporte_proveedores',
    name: 'Reporte proveedores',
    component: ReporteProveedor
  },
  {
    path: '/proveedores',
    name: 'Proveedores',
    component: Proveedores
  },
  {
    path: '/configuracion_smtp',
    name: 'configuracion smtp',
    component: ConfiguracionSMTP
  },
  {
    path: '/permisos_modulos',
    name: 'permisos modulos',
    component: PermisosModulos
  },
  {
    path: '/empresas',
    name: 'empresas',
    component: Empresas
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/usuarios",
    name: "usuarios",
    component: Usuarios
  },
  {
    path: "/roles",
    name: "roles",
    component: Roles
  },
  {
    path: "/clientes",
    name: "clientes",
    component: Clientes
  },
  {
    path: "/facturacion",
    name: "facturacion",
    component: indexFe
  },
  {
    path: "/compras",
    name: "compras",
    component: index
  },
  {
    path: "/librosiva",
    name: "librosiva",
    component: indexIVA
  },
  {
    path: "/anexosiva",
    name: "anexosiva",
    component: indexAnexos
  },
  {
    path: "/reporte_compras_ventas",
    name: "Reporte Ventas y Compras",
    component: indexReporte
  },
  {
    path: "/reporte_cxc",
    name: "Cuenta por Cobrar",
    component: indexCxc
  },

  {
    path: "/paises",
    name: "paises",
    component: Paises
  },
  {
    path: "/sucursales",
    name: "sucursales",
    component: Sucursales
  },
  {
    path: "/configuracion",
    name: "configuracion",
    component: Configuracion
  },
  {
    path: "/servicios",
    name: "servicios",
    component: Servicios
  },
  {
    path: "/vendedores",
    name: "vendedores",
    component: Vendedores
  },
  {
    path: "/productos",
    name: "productos",
    component: Productos
  },
  {
    path: "/permiso_botones",
    name: "permisos botones",
    component: PermisosBotones
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router